namespace MACRAIL.Ajax {

export function getAction(action: string, params: any): JQueryXHR {
    return this.callAction('GET', action, params);
}

export function postAction(action: string, params: any): JQueryXHR {
    return this.callAction('POST', action, params);
}

export function callAction(method: string, action: string, params: any): JQueryXHR {
    let request: JQueryAjaxSettings = {
        'type': method,
        'url':  MACRAIL.Helpers.makeUrl({ 'action': action }),
        'data': params,
    };

    return $.ajax(request);
}

export function getController(controller: string, action: string, params: any): JQueryXHR {
    return this.callController('GET', controller, action, params);
}

export function postController(controller: string, action: string, params: any): JQueryXHR {
    return this.callController('POST', controller, action, params);
}

export function callController(method: string, controller: string, action: string, params: any): JQueryXHR {
    let request: JQueryAjaxSettings = {
        'type': method,
        'url':  MACRAIL.Helpers.makeUrl({
            'controller': controller,
            'action': action,
         }),
        'data': params,
    };

    return $.ajax(request);
}

export function getScript() {
    // TODO
}

}
